// import { canUseDOM } from 'exenv';

export function companyDataLoading(resp = {}, store = {}) {
  return {
    type: 'COMPANY_DATA_LOADING',
    companyData: resp,
    store
  };
}

export function companyDataLoaded(resp = {}, store = {}) {
  return {
    type: 'COMPANY_DATA_LOADED',
    companyData: resp,
    store
  };
}

export function companyDataLoadError(error, store = {}) {
  return {
    type: 'COMPANY_DATA_ERROR',
    companyData: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
